export default __webpack_public_path__ + "static/media/uploadFile.138c9d7c.svg";